import * as React from 'react'
import * as PropTypes from "prop-types"
import * as _ from "lodash";
import { getAnnotatedText } from './utility/annotateLevenshteinSearch';

/**
 * Welcome to Markup, this will make your text look like a professor hated your paper.
 */
export class Markup extends React.Component {

  static propTypes = {
    textToMarkup: PropTypes.string,
    searchPhrases: PropTypes.arrayOf(PropTypes.shape({
      phrase: PropTypes.string,
      markupClassName: PropTypes.string,
      markupStyling: PropTypes.any,
      multi: PropTypes.bool
    })),
  };

  
  state = {
    annotated: []
  }
  
  componentDidUpdate(prevProps) {
    const same = _.isEqual(prevProps, this.props);
    if (!same) {
      this.setAnnotatedText(this.props)
    }
  }
  componentDidMount() {
    this.setAnnotatedText(this.props)
  }


  setAnnotatedText(props) {
    this.setState({ 
      annotated: getAnnotatedText(props.textToMarkup, props.searchPhrases) 
    });
  }

  /**
   * Given text to markup, along with phrases to search for, mark up the phrases that are contained within the text
   * to markup, with their corresponding modifiers (classname and/or style).
   *
   * The phrases that can be searched for can be multi word or single word phrases. i.e. you can provide a full sentence
   * with a paragraph and that whole sentence will be found. In order to find text, we are utilizing the Levenshtein Distance
   * of the n-gram to the search phrase. The n-gram contains the same amount of words as the search phrase.
   *
   */
  render() {
    const {
      textToMarkup,
      searchPhrases,
      ...rest
    } = this.props;
    return (
      <React.Fragment>{
          <span {...rest}>
            {this.state.annotated.filter( (x) => !!x ).map( (phrase, i) => {
              return (
                <span className={phrase.markupClassName} style={phrase.markupStyling} key={i} >
                  {`${phrase.term}`}
                </span>
              )
            })}
          </span>
      }</React.Fragment>
    )
  }

}
